import { render, staticRenderFns } from "./HubTextarea.vue?vue&type=template&id=90d14e92&scoped=true&"
import script from "./HubTextarea.vue?vue&type=script&lang=ts&"
export * from "./HubTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./HubTextarea.vue?vue&type=style&index=0&id=90d14e92&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d14e92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})
